
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import StatusBadge from '@/components/common/StatusBadge';
import { formatDate } from '@/utils/formatters';
import { SupportTicket } from '@/types';

interface RecentSupportTicketsProps {
  tickets: SupportTicket[];
  authors: any[];
  onViewAll: () => void;
}

const RecentSupportTickets: React.FC<RecentSupportTicketsProps> = ({ tickets, authors, onViewAll }) => {
  const navigate = useNavigate();

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <div>
          <CardTitle>Recent Support Tickets</CardTitle>
          <CardDescription>Latest inquiries from authors</CardDescription>
        </div>
        <div 
          className="cursor-pointer text-royalty-600 hover:text-royalty-800"
          onClick={onViewAll}
        >
          View All
        </div>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Author</TableHead>
              <TableHead>Subject</TableHead>
              <TableHead>Category</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Date</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {tickets.map((ticket) => {
              const author = authors.find(a => a.id === ticket.authorId);
              return (
                <TableRow key={ticket.id}>
                  <TableCell>{author?.name}</TableCell>
                  <TableCell>{ticket.subject}</TableCell>
                  <TableCell>{ticket.category}</TableCell>
                  <TableCell>
                    <StatusBadge status={ticket.status} />
                  </TableCell>
                  <TableCell>{formatDate(ticket.createdAt)}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default RecentSupportTickets;
